export default __webpack_public_path__ + "static/media/one.75bef1b0.png";